import styled from 'styled-components';
import { tokens } from '../../public/tokens';

const { colors, typography, globals } = tokens;

const variants = {
    success: colors.states.success.default,
    info: colors.states.info.default,
    alert: colors.states.alert.default,
    warning: colors.states.warning.default,
    neutral: colors.neutral.grey['400'],
};

/**
 * Compact status label. `$variant` only picks the background - the text stays
 * white on every variant, so a pill reads the same whatever it's reporting.
 */
export const Pill = styled.span(({ $variant = 'neutral' }) => ({
    display: 'flex',
    width: 'fit-content',
    minHeight: '22px',
    maxHeight: '22px',
    padding: '4px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    borderRadius: globals['border-radius'],
    backgroundColor: variants[$variant] || variants.neutral,
    color: colors.neutral.white,
    whiteSpace: 'nowrap',

    fontFamily: globals['font-family'],
    fontSize: typography.fontSize['md-12px'],
    fontWeight: typography.fontWeights.bold,
    lineHeight: typography.lineHeights['100'],
    fontFeatureSettings: "'liga' off, 'clig' off",
}));
